<add-drivers-to-vehicle-dialog *ngIf="visibleAddDriversToVhicle"
                              [_visibleAddDriversToVhicle]="visibleAddDriversToVhicle"
                              [_vehicleId]="vehicleId"
                              (changedVisibleAddDriversToVhicleEmit)="changedVisibleAddDriversToVhicleEmit($event)"/>

<edit-boundary-fee-dialog *ngIf="visibleEditBoundaryFeeDialog && operatorVehicle"
                          [_visibleEditBoundaryFeeDialog]="visibleEditBoundaryFeeDialog"
                          [boundaryFeeModel]="operatorVehicle.BoundaryFeeModel"
                          (boundaryFeeChange)="saveBoundaryFee($event)"
                          (changedVisibleEditBoundaryFeeDialog)="changedVisibleEditBoundaryFeeDialogEmit($event)"/>

<xp-gallery *ngIf="displayImg"
            class="vehicle-docs-gallery"
            [items]="galleryItems"
            [(activeIndex)]="activeGalleryImgIndex"
            [fullScreen]="true"
            (closed)="displayImg = false">
    <ng-template xpGalleryItem let-item>
        <ng-container *ngIf="item.isPdf; else progressimg">
            <iframe [src]="item.value" [style]="{ width: '500px', display: 'block', height: 'calc(80vh)'}"></iframe>
        </ng-container>
        <ng-template #progressimg>
            <img [src]="item.value" style="width: 100%; display: block; height: calc(80vh);" />
        </ng-template>
    </ng-template>
    <ng-template xpGalleryCaption let-item>
        <span>{{ item.title }}</span>
        <h5 style="margin-top: 10px;" *ngIf="item.expirationDate">
            Expiration: {{ item.expirationDate | date:'dd-MMM-yyyy' }}
        </h5>
    </ng-template>
</xp-gallery>

<!-- Deactivation confirmation dialog -->
<xp-dialog *ngIf="showDeactivationDialog" class="confirm-dialog" ariaLabel="Deactivate Vehicle?">
  <mat-card-header>
    <mat-card-title class="discard-header">Deactivate Vehicle?</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="discard-text">Are you sure you want to deactivate this vehicle? It will be moved to your inactive vehicles</div>
  </mat-card-content>
  <mat-card-actions align="end">
    <button mat-stroked-button class="mr-2" (click)="cancelDeactivation()">Cancel</button>
    <button mat-flat-button color="warn" (click)="deactivateVehicle()">Deactivate Vehicle</button>
  </mat-card-actions>
</xp-dialog>

<!-- Discard changes confirmation dialog -->
<xp-dialog *ngIf="discardConfirmDialog" class="confirm-dialog" ariaLabel="Discard changes?">
  <mat-card-header>
    <mat-card-title class="discard-header">Discard changes?</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="discard-text">Are you sure you want to discard all unsaved changes? All unsaved</div>
    <div class="mb-5">changes will be lost. This action cannot be undone.</div>
  </mat-card-content>
  <mat-card-actions align="end">
    <button mat-button (click)="cancelDiscard()">Cancel</button>
    <button mat-flat-button color="warn" (click)="discardConfirm()">Discard Changes</button>
  </mat-card-actions>
</xp-dialog>

<!-- Upload vehicle documents dialog -->
<xp-dialog *ngIf="showVehicleDocs" class="vehicle-docs-dialog">
  <xp-dialog-header class="docs-dialog-header" heading="Upload new vehicle documents" (closeClick)="showVehicleDocs = false; cancelDiscard()"></xp-dialog-header>
  <mat-card-content>
    <div class="docs-scroll-panel">
      <div class="pt-3 pb-3">
        <div class="col-12 p-0 mb-3">
          <div class="operator-add-vehicle-label">Vehicle Ownership</div>
          <div class="mt-3 flex align-items-center gap-2">
            <mat-slide-toggle [(ngModel)]="operatorVehicleOwnershipDocumentsModel.IsOwner"></mat-slide-toggle>
            <span class="ml-2">{{ operatorVehicleOwnershipDocumentsModel.IsOwner ? 'Owned' : 'Not owner' }}</span>
          </div>
        </div>
        <div class="col-12 p-0 mb-3">
          <div class="operator-add-vehicle-label">PA/CPC Case Number</div>
          <mat-form-field appearance="outline" class="w-100 mt-2">
            <mat-label>Enter PA/CPC Case Number</mat-label>
            <input matInput type="text"
                   [(ngModel)]="operatorVehicleOwnershipDocumentsModel.PaOrCpcCaseNumber"
                   placeholder="Enter PA/CPC Case Number" />
          </mat-form-field>
        </div>
        <div class="col-12 p-0 flex-row flex-wrap">
          <div class="col-6 p-0 mb-3 pr-2">
            <div class="operator-add-vehicle-label">LTO Official Receipt (OR)</div>
            <div class="mt-3">
              <xp-file-row class="mb-2"
                           *ngFor="let file of getUploadedFiles('LTOOfficialReceiptImageUrl')"
                           [thumbSrc]="file.url"
                           [isPdf]="file.isPdf"
                           pdfIconSrc="XpressApp/assets/images/pdf-icon.png"
                           iconSrc="Content/xpress-app/images/operator/signup/file-jpg.svg"
                           [name]="file.fileName || 'LTO Official Receipt (OR)'"
                           removeIconSrc="Content/xpress-app/images/operator/signup/remove-upload.svg"
                           (remove)="deleteUpload('LTOOfficialReceiptImageUrl', file.id)"></xp-file-row>
              <xp-drop-zone class="operator-add-vehicle-upload-field"
                            *ngIf="canUploadMoreFiles('LTOOfficialReceiptImageUrl')"
                            browseLabel="Browse File"
                            [accept]="acceptedVehicleDocTypes"
                            [multiple]="true"
                            [showProgress]="operatorVehicleOwnershipDocumentsModel.LTOOfficialReceiptImageUrlIsLoading"
                            (filesSelected)="fileBrowseHandler($event, 'LTOOfficialReceiptImageUrl')"></xp-drop-zone>
            </div>
            <div class="operator-add-vehicle-label mt-3">OR Expiration Date</div>
            <mat-form-field appearance="outline" class="mt-2 w-100">
              <mat-label>Select date</mat-label>
              <input matInput [matDatepicker]="orPicker"
                     [(ngModel)]="operatorVehicleOwnershipDocumentsModel.LTOOfficialReceiptExpireAt"
                     [min]="minDate">
              <mat-datepicker-toggle matSuffix [for]="orPicker"></mat-datepicker-toggle>
              <mat-datepicker #orPicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-6 p-0 mb-3 pl-2">
            <div class="operator-add-vehicle-label">Certificate of Registration (CR)</div>
            <div class="mt-3">
              <xp-file-row class="mb-2"
                           *ngFor="let file of getUploadedFiles('CertificateRegistrationImageUrl')"
                           [thumbSrc]="file.url"
                           [isPdf]="file.isPdf"
                           pdfIconSrc="XpressApp/assets/images/pdf-icon.png"
                           iconSrc="Content/xpress-app/images/operator/signup/file-jpg.svg"
                           [name]="file.fileName || 'Certificate of Registration (CR)'"
                           removeIconSrc="Content/xpress-app/images/operator/signup/remove-upload.svg"
                           (remove)="deleteUpload('CertificateRegistrationImageUrl', file.id)"></xp-file-row>
              <xp-drop-zone class="operator-add-vehicle-upload-field"
                            *ngIf="canUploadMoreFiles('CertificateRegistrationImageUrl')"
                            browseLabel="Browse File"
                            [accept]="acceptedVehicleDocTypes"
                            [multiple]="true"
                            [showProgress]="operatorVehicleOwnershipDocumentsModel.CertificateRegistrationImageUrlIsLoading"
                            (filesSelected)="fileBrowseHandler($event, 'CertificateRegistrationImageUrl')"></xp-drop-zone>
            </div>
          </div>
          <div class="col-6 p-0 mb-3 pr-2" *ngIf="!operatorVehicleOwnershipDocumentsModel.IsOwner">
            <div class="operator-add-vehicle-label">SPA</div>
            <div class="mt-3">
              <xp-file-row class="mb-2"
                           *ngFor="let file of getUploadedFiles('SPAImageUrl')"
                           [thumbSrc]="file.url"
                           [isPdf]="file.isPdf"
                           pdfIconSrc="XpressApp/assets/images/pdf-icon.png"
                           iconSrc="Content/xpress-app/images/operator/signup/file-jpg.svg"
                           [name]="file.fileName || 'SPA'"
                           removeIconSrc="Content/xpress-app/images/operator/signup/remove-upload.svg"
                           (remove)="deleteUpload('SPAImageUrl', file.id)"></xp-file-row>
              <xp-drop-zone class="operator-add-vehicle-upload-field"
                            *ngIf="canUploadMoreFiles('SPAImageUrl')"
                            browseLabel="Browse File"
                            [accept]="acceptedVehicleDocTypes"
                            [multiple]="true"
                            [showProgress]="operatorVehicleOwnershipDocumentsModel.SPAImageUrlIsLoading"
                            (filesSelected)="fileBrowseHandler($event, 'SPAImageUrl')"></xp-drop-zone>
            </div>
          </div>
          <div class="col-6 p-0 mb-3 pr-2">
            <div class="operator-add-vehicle-label">PA Document</div>
            <div class="mt-3">
              <xp-file-row class="mb-2"
                           *ngFor="let file of getUploadedFiles('ProvisionalAuthorityImageUrl')"
                           [thumbSrc]="file.url"
                           [isPdf]="file.isPdf"
                           pdfIconSrc="XpressApp/assets/images/pdf-icon.png"
                           iconSrc="Content/xpress-app/images/operator/signup/file-jpg.svg"
                           [name]="file.fileName || 'PA Document'"
                           removeIconSrc="Content/xpress-app/images/operator/signup/remove-upload.svg"
                           (remove)="deleteUpload('ProvisionalAuthorityImageUrl', file.id)"></xp-file-row>
              <xp-drop-zone class="operator-add-vehicle-upload-field"
                            *ngIf="canUploadMoreFiles('ProvisionalAuthorityImageUrl')"
                            browseLabel="Browse File"
                            [accept]="acceptedVehicleDocTypes"
                            [multiple]="true"
                            [showProgress]="operatorVehicleOwnershipDocumentsModel.ProvisionalAuthorityImageUrlIsLoading"
                            (filesSelected)="fileBrowseHandler($event, 'ProvisionalAuthorityImageUrl')"></xp-drop-zone>
            </div>
            <div class="operator-add-vehicle-label mt-3">PA Expiration Date</div>
            <mat-form-field appearance="outline" class="mt-2 w-100">
              <mat-label>Select date</mat-label>
              <input matInput [matDatepicker]="paPicker"
                     [(ngModel)]="operatorVehicleOwnershipDocumentsModel.ProvisionalAuthorityExpireAt"
                     [min]="minDate">
              <mat-datepicker-toggle matSuffix [for]="paPicker"></mat-datepicker-toggle>
              <mat-datepicker #paPicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-6 p-0 mb-3 pl-2">
            <div class="operator-add-vehicle-label">CPC Document</div>
            <div class="mt-3">
              <xp-file-row class="mb-2"
                           *ngFor="let file of getUploadedFiles('CertificatePublicConvenienceImageUrl')"
                           [thumbSrc]="file.url"
                           [isPdf]="file.isPdf"
                           pdfIconSrc="XpressApp/assets/images/pdf-icon.png"
                           iconSrc="Content/xpress-app/images/operator/signup/file-jpg.svg"
                           [name]="file.fileName || 'CPC Document'"
                           removeIconSrc="Content/xpress-app/images/operator/signup/remove-upload.svg"
                           (remove)="deleteUpload('CertificatePublicConvenienceImageUrl', file.id)"></xp-file-row>
              <xp-drop-zone class="operator-add-vehicle-upload-field"
                            *ngIf="canUploadMoreFiles('CertificatePublicConvenienceImageUrl')"
                            browseLabel="Browse File"
                            [accept]="acceptedVehicleDocTypes"
                            [multiple]="true"
                            [showProgress]="operatorVehicleOwnershipDocumentsModel.CertificatePublicConvenienceImageUrlIsLoading"
                            (filesSelected)="fileBrowseHandler($event, 'CertificatePublicConvenienceImageUrl')"></xp-drop-zone>
            </div>
            <div class="operator-add-vehicle-label mt-3">CPC Expiration Date</div>
            <mat-form-field appearance="outline" class="mt-2 w-100">
              <mat-label>Select date</mat-label>
              <input matInput [matDatepicker]="cpcPicker"
                     [(ngModel)]="operatorVehicleOwnershipDocumentsModel.CertificatePublicConvenienceExpireAt"
                     [min]="minDate">
              <mat-datepicker-toggle matSuffix [for]="cpcPicker"></mat-datepicker-toggle>
              <mat-datepicker #cpcPicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </mat-card-content>
  <mat-card-actions align="end">
    <button mat-stroked-button type="button" class="mr-2" (click)="discardChanges()">Discard Changes</button>
    <button mat-flat-button color="primary" type="button" (click)="updateDocuments()">Submit</button>
  </mat-card-actions>
</xp-dialog>

<!-- Loading spinner -->
<xp-loading class="loading-spinner-center" [diameter]="64" *ngIf="isLoading"></xp-loading>

<xp-detail-layout class="vehicle-detail-main" *ngIf="!isLoading && operatorVehicle">
  <div xpDetailLayoutSide class="vehicle-detail-side">
    <xp-back-button class="back-to-login-btn mb-2"
                    iconSrc="../Content/xpress-app/images/operator/signup/arrow-left.svg"
                    (click)="backToOperatorVehicles()">Back</xp-back-button>

    <div class="operator-vehicle-block">
      <div class="flex flex-row justify-content-between w-100 align-items-center mb-2">
        <div class="operator-vehicle-block__vehicle-name">
          {{operatorVehicle.VehicleBrandName}} {{operatorVehicle.VehicleModelName}} {{operatorVehicle.NumberPlate}}
        </div>
        <div class="flex flex-row align-items-center vehicle-status-toggle">
          <div class="mr-2 vehicle-active-name"
               [class]="(operatorVehicle.IsActive) ? 'blue-color' : 'red-color'">
            {{operatorVehicle.IsActive ? 'Active' : 'Inactive'}}
          </div>
          <mat-slide-toggle [(ngModel)]="operatorVehicle.IsActive"
                            [disabled]="!canToggleVehicleActive()"
                            (change)="onChangeSwitch($event)"></mat-slide-toggle>
        </div>
      </div>

      <xp-badge class="vehicle-approval-status"
                [ngClass]="{
                  'vehicle-approval-status--pending': getApprovalStatus() === 'Pending',
                  'vehicle-approval-status--approved': getApprovalStatus() === 'Approved',
                  'vehicle-approval-status--rejected': getApprovalStatus() === 'Rejected'
                }"
                [icon]="getApprovalStatus() === 'Approved' ? 'check_circle' : null"
                [iconSrc]="getApprovalStatusIconSrc()">{{ getApprovalStatusLabel() }}</xp-badge>

      <div class="vehicle-hero-image" *ngIf="vehicleHeroImageUrl">
        <img [src]="vehicleHeroImageUrl" alt="" />
      </div>

      <div class="operator-vehicle-block__vehicle-info">
        <xp-info-row class="vehicle-info-row" label="Vehicle Type">{{operatorVehicle.VehicleTypeText}}</xp-info-row>
        <xp-info-row class="vehicle-info-row" label="Vehicle Make">{{operatorVehicle.VehicleBrandName}}</xp-info-row>
        <xp-info-row class="vehicle-info-row" label="Vehicle Model">{{operatorVehicle.VehicleModelName}}</xp-info-row>
        <xp-info-row class="vehicle-info-row" label="Build Year">{{operatorVehicle.VehicleYear}}</xp-info-row>
        <xp-info-row class="vehicle-info-row" label="Vehicle Color">{{operatorVehicle.VehicleColorText}}</xp-info-row>
        <xp-info-row class="vehicle-info-row" label="Plate No.">{{operatorVehicle.NumberPlate}}</xp-info-row>
        <xp-info-row class="vehicle-info-row" label="Vehicle Ownership">{{operatorVehicle.IsOwner ? 'Owned' : 'Not owner'}}</xp-info-row>
        <xp-info-row class="vehicle-info-row" label="TNC">XPRESS</xp-info-row>
      </div>

      <div class="vehicle-gallery-wrap" *ngIf="galleryVehicleItems.length > 0">
        <xp-gallery [items]="galleryVehicleItems" [visibleThumbnails]="visibleThumbnails">
          <ng-template xpGalleryItem let-item>
            <img [src]="item.value" class="gallerry-item-img" alt="" />
          </ng-template>
          <ng-template xpGalleryThumbnail let-item>
            <div class="gallery-thumb-wrap">
              <img [src]="item.value" class="thumbnail-img" alt="" />
            </div>
          </ng-template>
        </xp-gallery>
      </div>
    </div>
  </div>

  <div class="vehicle-detail-content">
    <mat-tab-group (selectedIndexChange)="handleTabChange($event)"
                   class="vehicle-tab-group"
                   animationDuration="0ms"
                   [dynamicHeight]="true">

      <!-- Insights tab -->
      <mat-tab label="Insights">
        <div class="tab-scroll-panel">
          <operator-vehicle-insights [vehicleId]="vehicleId"/>
        </div>
      </mat-tab>

      <!-- Legal Docs tab -->
      <mat-tab label="Legal Docs">
        <div class="tab-scroll-panel">
          <div class="flex flex-column justify-content-between h-calc">
            <div>
              <div class="mt-5 common-font-medium docs-header">Vehicle Docs</div>
              <div class="sb-block-img">
                <div class="sb-block-img-30" *ngFor="let image of legalDocsImages; let index = index">
                  <button xpDocThumb
                          class="legal-doc-card"
                          [src]="image.value"
                          [isPdf]="image.isPdf"
                          pdfIconSrc="XpressApp/assets/images/pdf-icon.png"
                          [label]="image.title"
                          [caption]="image.fileName"
                          [note]="image.expirationDate ? ('Expiration: ' + (image.expirationDate | date:'dd-MMM-yyyy')) : ''"
                          (open)="showVisibleImageModal(legalDocsImages, index)"></button>
                </div>
              </div>
            </div>
            <div class="flex flex-row justify-content-end gap-2 mt-3">
              <button mat-flat-button color="primary" type="button" (click)="showVehicleDocs = true">Upload New Document</button>
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- Drivers tab -->
      <mat-tab label="Drivers">
        <div class="tab-scroll-panel">
          <div *ngIf="(drivers && drivers.length > 0) || filter.search">
            <xp-section-header class="drivers-table-toolbar" heading="Assigned Drivers">
              <xp-search-field class="search-field"
                               [(value)]="filter.search"
                               (valueChange)="handleFilterChange()"
                               placeholder="Search Driver"></xp-search-field>
              <button mat-flat-button
                      color="primary"
                      [disabled]="!canAssignDrivers()"
                      (click)="openAddDriversDialog()">Add Driver</button>
            </xp-section-header>

            <div xpTable class="drivers-table-wrap">
              <table mat-table [dataSource]="drivers" matSort (matSortChange)="onSortChange($event)">
                <ng-container matColumnDef="RiderId">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Driver ID</th>
                  <td mat-cell *matCellDef="let driver">{{driver.RiderId}}</td>
                </ng-container>
                <ng-container matColumnDef="UserName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Driver Name</th>
                  <td mat-cell *matCellDef="let driver">{{driver.UserName}}</td>
                </ng-container>
                <ng-container matColumnDef="Phone">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone No.</th>
                  <td mat-cell *matCellDef="let driver">{{driver.Phone}}</td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="actions-col">Action</th>
                  <td mat-cell *matCellDef="let driver" class="actions-col">
                    <button xpButton
                            variant="icon"
                            type="button"
                            class="icon-remove-block"
                            (click)="removeRiderFromOperatorVehicle(driver.RiderId)"
                            aria-label="Remove driver">
                      <img src="/Content/xpress-app/images/svg/icon_delete.svg" alt="" />
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </div>

            <mat-paginator [length]="totalRecords"
                           [pageSize]="rowsPerPage"
                           [pageIndex]="pageIndex"
                           [pageSizeOptions]="rowsPerPageOptions"
                           (page)="onPageChange($event)"
                           showFirstLastButtons>
            </mat-paginator>
          </div>

          <xp-empty-state class="flex flex-column justify-content-center align-items-center flex-1 driver-not-content"
               *ngIf="drivers.length === 0 && !filter.search"
               imageSrc="/Content/xpress-app/images/no-drivers.png"
               title="No Drivers Yet"
               description="You will able to see all your assigned drivers here">
            <div class="bluedark-btn border-radius-30px"
                 *ngIf="canAssignDrivers()"
                 (click)="openAddDriversDialog()">
              <div class="flex flex-row">
                <div>
                  <img class="driver-not-plus-circle-icon" src="/XpressApp/assets/images/plus-circle-icon.svg" />
                </div>
                <div>Add Drivers</div>
              </div>
            </div>
            <div class="driver-not-description" *ngIf="!canAssignDrivers()">
              Drivers can only be assigned after the vehicle is approved.
            </div>
          </xp-empty-state>
        </div>
      </mat-tab>

      <!-- Boundary Fee tab -->
      <mat-tab label="Boundary Fee">
        <div class="tab-scroll-panel">
          <div class="flex flex-column justify-content-between h-calc">
            <div class="p-3 boundary-fee-panel">
              <div class="mb-3 common-font-medium docs-header">Boundary Fee</div>
              <xp-info-row class="fee-row" label="Boundary Amount">₱{{operatorVehicle.BoundaryFeeModel.BoundaryAmount}}</xp-info-row>
              <xp-info-row class="fee-row" label="Processing Fee">₱{{operatorVehicle.BoundaryFeeModel.BoundaryProcessingFee}}</xp-info-row>
              <xp-info-row class="fee-row" label="Days Applied">
                <span [matTooltip]="operatorVehicle.BoundaryFeeModel.DaysApplied">
                  {{operatorVehicle.BoundaryFeeModel.DaysApplied.length > 30
                    ? operatorVehicle.BoundaryFeeModel.DaysApplied.slice(0, 30) + '...'
                    : operatorVehicle.BoundaryFeeModel.DaysApplied}}
                </span>
              </xp-info-row>
              <xp-info-row class="fee-row" label="Boundary Duration From">
                {{operatorVehicle.BoundaryFeeModel.BoundaryAvailableFromHours.toString().padStart(2, '0') + ':' + operatorVehicle.BoundaryFeeModel.BoundaryAvailableFromMins.toString().padStart(2, '0')}}
              </xp-info-row>
              <xp-info-row class="fee-row" label="Boundary Duration To">
                {{operatorVehicle.BoundaryFeeModel.BoundaryAvailableToHours.toString().padStart(2, '0') + ':' + operatorVehicle.BoundaryFeeModel.BoundaryAvailableToMins.toString().padStart(2, '0')}}
              </xp-info-row>
            </div>
            <div class="flex flex-row justify-content-end gap-2 mt-3">
              <button mat-flat-button color="primary" type="button" (click)="openEditBoundaryFeeDialog()">Edit Boundary</button>
            </div>
          </div>
        </div>
      </mat-tab>

    </mat-tab-group>
  </div>
</xp-detail-layout>
